import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class CurrenciesService extends BaseService {
  static get entity () {
    return 'v1/currencies'
  }

  static async getCurrencies() {
  
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}`)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      console.log(error)
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}